// extracted by mini-css-extract-plugin
module.exports = {"paddingLess":"Wrap-styles-module--paddingLess--1bo47","white":"Wrap-styles-module--white--3M4wu","wrap":"Wrap-styles-module--wrap--2S3WX"};